export default __webpack_public_path__ + "static/media/mcv-lgoo.8c181cd7.svg";